import { render, staticRenderFns } from "./MatchListView.vue?vue&type=template&id=11e8a874&"
import script from "./MatchListView.vue?vue&type=script&lang=js&"
export * from "./MatchListView.vue?vue&type=script&lang=js&"
import style0 from "./MatchListView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports